"use client";

import { useState } from "react";
import { Play } from "lucide-react";
import {
  VOLUME_BOT_DEMO_VIDEO,
  VOLUME_BOT_YOUTUBE_VIDEO,
} from "@/config/volumeBotMedia";

/** YouTube iframe loads only on click — keeps lab TBT/SI clear of embed JS. */
export default function VolumeBotYouTubeEmbed() {
  const { embedUrl, iframeTitle } = VOLUME_BOT_YOUTUBE_VIDEO;
  const { posterUrl, title } = VOLUME_BOT_DEMO_VIDEO;
  const [shouldLoadIframe, setShouldLoadIframe] = useState(false);

  return (
    <section
      className="mx-auto mb-8 max-w-5xl sm:mb-12 [content-visibility:auto] [contain-intrinsic-size:360px]"
      aria-labelledby="volume-bot-video-heading"
    >
      <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-4 shadow-2xl sm:p-6">
        <div className="mb-4 text-center sm:mb-6">
          <h2
            id="volume-bot-video-heading"
            className="mb-1 text-xl font-semibold text-white sm:mb-2 sm:text-2xl"
          >
            Watch How It Works
          </h2>
          <p className="text-sm text-gray-400 sm:text-base">
            See IDX AutoBot in action
          </p>
        </div>

        <div
          className="relative w-full overflow-hidden rounded-xl"
          style={{ paddingBottom: "56.25%" }}
        >
          {shouldLoadIframe ? (
            <iframe
              className="absolute top-0 left-0 h-full w-full"
              src={embedUrl}
              title={iframeTitle}
              frameBorder="0"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          ) : (
            <button
              type="button"
              className="group absolute inset-0 h-full w-full"
              onClick={() => setShouldLoadIframe(true)}
              aria-label={`Play video: ${title}`}
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={posterUrl}
                alt={title}
                width={896}
                height={504}
                decoding="async"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <span
                className="absolute inset-0 bg-black/35 transition-opacity group-hover:bg-black/25"
                aria-hidden
              />
              <span
                className="absolute inset-0 flex items-center justify-center"
                aria-hidden
              >
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-cyan-500/90 text-white shadow-lg shadow-cyan-900/40 transition-transform group-hover:scale-105 sm:h-16 sm:w-16">
                  <Play className="ml-0.5 h-7 w-7 fill-current sm:h-8 sm:w-8" />
                </span>
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
